import { apiClient } from "@/lib/api-client";
import type { LinkWalletStatus } from "@/types/linkWallet.ts";
import { queryOptions } from "@tanstack/react-query";

/** Keep a wallet setup flow separate from settings and refresh while Link awaits the user. */
export const linkWalletQueryOptions = (flow?: string) => queryOptions({
  queryKey: ["linkWallet", flow ?? "settings"],
  queryFn: async ({ signal }) => (await apiClient.get<LinkWalletStatus>("/api/a/payments/link", { signal, params: { flow } })).data,
  retry: false,
  refetchInterval: (query) => !query.state.error && query.state.data?.status === "connecting" ? 3000 : false,
});

/** Start or resume Kernel's hosted connection for the current owner and originating conversation. */
export const startLinkConnection = async (flow?: string) => (await apiClient.post<LinkWalletStatus>("/api/a/payments/link/connect", flow ? { flow } : {})).data;
